export default import.meta.ROLLDOWN_FILE_URL_J12BXNymBmaPDkbkABZ18w